import axios from './axios'
import { IFarmAPIResponse, IFarmFormDefault } from '../@types/refact/IFarmAPI'

const getFarmsByUser = (): Promise<IFarmAPIResponse[]> => {
    return axios.get<IFarmAPIResponse[]>(`/farms/user`).then(({ data }) => {
        return data
    })
}

const getFarmByIdForForm = (farmId: number): Promise<IFarmFormDefault> => {
    return axios.get<IFarmAPIResponse>(`/farms/${farmId}`).then(({ data }) => {
        return {
            id: data.id,
            name: data.name,
            initials: data.initials,
            document: data.document || "",
            state_registration: data.state_registration || "",
            owner_user_id: data.owner_user.id,
            owner_user_name: data.owner_user.name,
            address: {
                state: data.address.state,
                city: {
                    code: data.address.city.code,
                    name: data.address.city.name,
                },
            },
            season: data.properties.season,
            map_coords: data.map_coords,
        }
    })
}

export const farmService = {
    getFarmsByUser,
    getFarmByIdForForm
}